import { create } from 'zustand';
import { ApiUtils, CustomerApi, type CustomerEntity, RequestStrategyEnum } from '@shared/api';

interface UseTransactionCustomerStore {
  loading: boolean;
  data: CustomerEntity | null;
  error: string | null;
  getCustomer: (customerId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useTransactionCustomerStore = create<UseTransactionCustomerStore>((set) => ({
  loading: false,
  error: null,
  data: null,

  getCustomer: ApiUtils.wrapperApi(async (customerId, signal) => {
    try {
      set({ loading: true, data: null, error: null });
      const result = await CustomerApi.getCustomer(customerId, signal);
      set({ loading: false, data: result ?? null });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: null, error: null }),
}));
